module.exports = __webpack_public_path__ + "img/2647371-60-4.38f4fb31.png";